exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".DevGrid {\n  display: none;\n  position: fixed;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  top: 0;\n  z-index: 100;\n  opacity: 0.1;\n  pointer-events: none; }\n  .DevGrid-row {\n    max-width: 1080px;\n    margin-left: auto;\n    margin-right: auto;\n    height: 100%; }\n    .DevGrid-row:after {\n      content: \" \";\n      display: block;\n      clear: both; }\n  .DevGrid-col {\n    width: 3.125%;\n    float: left;\n    margin-left: 1.5625%;\n    margin-right: 1.5625%;\n    height: 100%;\n    border: 1px solid red;\n    background: rgba(255, 0, 0, 0.2); }\n", ""]);

// exports
